import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ProjectStepperContainer from '../../containers/projectmng/stepper/ProjectStepperContainer';

const ProjectStepPage = () => {
  const { id, step, tab } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [activeTap, setActiveTap] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    if (step) {
      setActiveStep(Number(step));
      //  console.log(step,'step');
    }
    if (tab) {
      setActiveTap(Number(tab - 1));
      // console.log(tab,'tab');
    }
  }, [id, step, tab]);

  const handleTabChange = (event, newValue) => {
    // console.log('handleTabChange', newValue);
    // setActiveTap(newValue);
    let newStep = newValue + 1;
    navigate(`/projectmng/${id}/${step}/${newStep}`);
  };

  const handleGoBack = () => {
    navigate('/projectmng');
  };

  return (
    <Box>
      <ProjectStepperContainer
        pageUrl="projectmng"
        activeStep={activeStep}
        activeTap={activeTap}
        handleTabChange={handleTabChange}
        handleGoBack={handleGoBack}
      />
    </Box>
  );
};

export default ProjectStepPage;
